module.exports = __webpack_public_path__ + "static/media/sent.b93b796e.svg";